import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import intlShape from '@/shared/utils/intlShape';
import moment from 'moment';

const getTranslation = (intl, message) => {
  if (!message) return null;
  if (typeof message === 'string') return message;
  if (message.id) return intl.formatMessage(message);
  return null;
};

class YearSelect extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    value: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ id: PropTypes.string.isRequired }),
    ]),
    yearsInPast: PropTypes.number,
    yearsInFuture: PropTypes.number,
    withoutOption: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ id: PropTypes.string.isRequired }),
    ]),
    required: PropTypes.bool,
  };
  static defaultProps = {
    placeholder: null,
    value: null,
    yearsInPast: 5,
    yearsInFuture: 1,
    required: false,
    withoutOption: null,
  };

  state = {
    years: [],
  };

  componentDidMount() {
    const { yearsInPast, yearsInFuture } = this.props;
    const currentYear = moment.utc().year();
    const startYear = currentYear - Math.max(0, yearsInPast || 0);
    const endYear = currentYear + Math.max(0, yearsInFuture || 0);
    const years = [];
    for (let y = startYear; y <= endYear; y++) {
      years.push(y);
    }
    this.setState({ years });
  }

  selectedValueChanged(e) {
    const { onChange, withoutOption } = this.props;
    let value = parseInt(e.target.value);
    if (value === 0 && !!withoutOption) {
      onChange(0);
      return;
    }

    if (!value || value < 2000) value = null;
    onChange(value);
  }

  render() {
    const { years } = this.state;
    const {
      intl,
      value,
      placeholder,
      required,
      withoutOption,
      yearsInPast,
      yearsInFuture,
      ...otherProps
    } = this.props;
    const extraValue = !!value && years.indexOf(value) < 0;
    const placeholderLabel = getTranslation(intl, placeholder);
    const withoutOptionLabel = getTranslation(intl, withoutOption);
    return (
      <select
        className="form-control"
        {...otherProps}
        onChange={e => this.selectedValueChanged(e)}
        value={value ?? ''}
      >
        {(!required || !value) && <option value="">{placeholderLabel}</option>}
        {withoutOptionLabel && <option value={0}>{withoutOptionLabel}</option>}
        {extraValue && <option value={value}>{value}</option>}
        {years &&
          years.map(y => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
      </select>
    );
  }
}

export default injectIntl(YearSelect);
